import React from 'react';
import { Box, Divider, Paper, useMediaQuery, useTheme } from '@mui/material';

import { isUsingCustomTheme } from '@paragon/login-tools';

import { useAppSelector } from '../../hooks';
import FloatingPoweredByParagon from '../../misc/FloatingPoweredByParagon';
import { SaveStatusIndicator } from './SaveStatusIndicator';
import { StatusBarNotifier } from './StatusBarNotifier';

export function StatusBar() {
  const theme = useTheme();
  const visible = useMediaQuery(theme.breakpoints.up('md'));
  const showPoweredByParagon = useAppSelector(isUsingCustomTheme);

  if (!visible) return;

  return (
    <Paper
      elevation={0}
      sx={{
        maxHeight: '35px',
        display: 'flex',
        alignItems: 'center',
        borderRadius: 0,
        borderTop: 'thin solid',
        borderColor: 'divider',
        userSelect: 'none',
      }}
    >
      <StatusBarNotifier />
      <Divider orientation="vertical" flexItem />

      <Box sx={{ flexGrow: 1 }} />

      <SaveStatusIndicator />
      <Divider orientation="vertical" flexItem />
      {showPoweredByParagon && <FloatingPoweredByParagon />}
    </Paper>
  );
}
